import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

import mediaQueries from '@/theme/mediaQueries';

export const Container = styled.div`
    width: 100%;

    ${mediaQueries.laptop} {
        padding: 48px 0 48px 56px;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 12px;
    align-items: center;
    margin-bottom: 24px;
`;

export const Link = styled(RouterLink)`
    border-radius: 100%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme['surface-default']};
`;
